// SETTINGS V2 atom — SField. Presentational label/error/unit wrapper for a
// NON-text control (SToggle, SCheck, custom rows). For text inputs use
// SInputField (the shared-wrapper adapter). Port of settings-kit.jsx SField
// (lines 48-57). Inline styles + CSS-var tokens only.
import React from "react";

export interface SFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  unit?: string;
  children: React.ReactNode;
}

const SField: React.FC<SFieldProps> = ({
  label,
  required,
  error,
  unit,
  children,
}) => (
  <div style={{ minWidth: 0 }}>
    <div className="eyebrow" style={{ color: "var(--muted)", marginBottom: 6 }}>
      {label}
      {required && <span style={{ color: "var(--mod-accent)" }}> *</span>}
    </div>
    {children}
    {unit && (
      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 9.5,
          color: "var(--faint)",
          marginTop: 4,
          letterSpacing: "0.04em",
        }}
      >
        {unit}
      </div>
    )}
    {error && (
      <div style={{ fontSize: 11.5, color: "var(--red)", marginTop: 4 }}>
        {error}
      </div>
    )}
  </div>
);

export default SField;
